import ApplicationSerializer from 'teacher-ui-client/serializers/application'

export default class SchoolStatisticsSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(payloadKey: string) {
    return payloadKey === 'statistics' ? 'school-statistic' : super.modelNameFromPayloadKey(payloadKey)
  }
}
